import { DateTime } from 'luxon';
import { addIstDays, type TemplateDayDto } from '@pams/shared';

/**
 * ─────────────────────────────────────────────────────────────────────────────────────
 *  ⚠️ [P7B §4b] "FILL FROM ONE DAY" — EVERY OTHER DAY AT ITS DISTANCE FROM THE ANCHOR IN THE BOOKLET.
 *
 *  The offsets are the SOURCE year's: Chaturthi to Dashami was nine days in 2025, so a 2026 Chaturthi on
 *  the 14th puts Dashami on the 23rd. Every day is then still edited on its own — tithis merge and skip
 *  from year to year, which is why a calendar is per day and this is only a starting point.
 *
 *  ⚠️ CALENDAR DATES, NEVER INSTANTS. The distance is measured between two `YYYY-MM-DD` strings read in
 *  UTC (a date has no zone; reading both in one zone makes the difference exact), and the new date is
 *  `addIstDays` — the shared crossing every other business-date step uses. No `toISOString().slice()`.
 * ─────────────────────────────────────────────────────────────────────────────────────
 */
export const daysBetween = (from: string, to: string): number =>
  Math.round(DateTime.fromISO(to, { zone: 'utc' }).diff(DateTime.fromISO(from, { zone: 'utc' }), 'days').days);

export const fillFromAnchor = (
  days: readonly TemplateDayDto[],
  anchorKey: string,
  anchorDate: string,
): Record<string, string> => {
  const anchor = days.find((day) => day.key === anchorKey);
  if (!anchor) return {};
  return Object.fromEntries(
    days.map((day) => [day.key, addIstDays(anchorDate, daysBetween(anchor.sourceDate, day.sourceDate))]),
  );
};
